import React, { useState } from 'react';
import { MotifDropdownPortal } from '@ey-xd/motif-react';

import { useOutsideInteraction } from 'common/hooks/useOutsideInteraction';
import { ICON_COLLECTION } from 'assets/media/icons';

import IconButton from '../icon-button';
import Icon from '../icon';

import './DropdownPortal.scss';

type DropdownProps = {
    id?: string;
    triggerId?: string;
    children?: React.ReactNode;
    className?: string;
    allowOutsideInteraction?: boolean;
};

const Dropdown = ({
    id,
    triggerId,
    children,
    className,
    allowOutsideInteraction
}: DropdownProps) => {
    const [isDropdownOpen, setDropDownOpen] = useState<boolean>(false);

    const handleOutsideInteraction = () => {
        if (!allowOutsideInteraction) {
            // Temp solution to fix dropdown closing before option click event
            setTimeout(() => {
                setDropDownOpen(false);
            }, 100);
            document.getElementById(`dropdown-option-button-${triggerId}`)?.blur();
        }
    };

    const dropdownRef = useOutsideInteraction(handleOutsideInteraction);

    return (
        <div ref={dropdownRef} className={`motif-col-xs-1 dropdown-wrapper ${className}`}>
            <MotifDropdownPortal
                open={isDropdownOpen}
                className="dropdown"
                id={id}
                aria-labelledby={triggerId}
                handleClickOutside={() => setDropDownOpen(false)}
                trigger={
                    <IconButton
                        id={`dropdown-option-button-${triggerId}`}
                        type="button"
                        onClick={() => setDropDownOpen(!isDropdownOpen)}
                        aria-label="dropdownOptions">
                        <Icon src={ICON_COLLECTION.IC_Setting} />
                    </IconButton>
                }>
                {children}
            </MotifDropdownPortal>
        </div>
    );
};

export default Dropdown;
